import './_jquery';

jQuery(function() {
  $('[data-header-menu-animation="true"]').on('click', function() {
    $(this).toggleClass('is-active');
    $('[data-header-mobile-submenu="true"]').toggleClass('show-element');
    $('body').toggleClass('no-scroll');
    $('.site-content__right_side_cta').toggleClass('hidden');
  });
});
